import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfProductCompareC from '@elem/ui/ef-product-compare-c';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.TabC');
    const { locale = 'us' } = useRouter();
    const imgAllA = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724990336787/sl_r3.png',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725015852850/r3_eu.png',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725015937853/r3_uk.png',
        },
        AU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736821168102/5_R3_UPS.png',
        },
        PH: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751251095899/r3-ups.png',
        },
    };
    const imgLocaleA: any = {
        us: imgAllA.NA,
        ca: imgAllA.NA,
        br: imgAllA.NA,
        mx: imgAllA.NA,
        uk: imgAllA.UK,
        eu: imgAllA.EU,
        de: imgAllA.EU,
        fr: imgAllA.EU,
        it: imgAllA.EU,
        es: imgAllA.EU,
        au: imgAllA.AU,
        ph: imgAllA.PH,
    };
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];

    const imgAllB = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724990336706/sl_r3p.png',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725015884744/r3_plus_eu.png',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725015958676/r3_plus_uk.png',
        },
        PH: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751251096279/r3p.png',
        },
    };
    const imgLocaleB: any = {
        us: imgAllB.NA,
        ca: imgAllB.NA,
        br: imgAllB.NA,
        mx: imgAllB.NA,
        uk: imgAllB.UK,
        eu: imgAllB.EU,
        de: imgAllB.EU,
        fr: imgAllB.EU,
        it: imgAllB.EU,
        es: imgAllB.EU,
        ph: imgAllB.PH,
    };
    const imgB = imgLocaleB[locale] || imgLocaleB['eu'];
    const listA = {
        pc: imgA.pc,
        title: t('win3_a_title'),
        specList: [
            {
                desc: t('win3_a_item1_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon
                            className="win3_item_title_icon"
                            pc={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1752458098781/d1.png'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1723727559364/d1.png'
                            }
                        />
                        <div className="win3_item_title_text">{t('win3_a_item1_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_a_item2_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127710/d2.png" />
                        <div className="win3_item_title_text">{t('win3_a_item2_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_a_item3_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728163210/d3.png" />
                        <div className="win3_item_title_text">{t('win3_a_item3_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_a_item4_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127912/d4.png" />
                        <div className="win3_item_title_text">{t('win3_a_item4_b')}</div>
                    </div>
                ),
            },
        ],
    };

    const listB = {
        pc: imgB.pc,
        title: t('win3_b_title'),
        specList: [
            {
                desc: t('win3_b_item1_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon
                            className="win3_item_title_icon"
                            pc={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1752458098781/d1.png'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1723727559364/d1.png'
                            }
                        />
                        <div className="win3_item_title_text">{t('win3_b_item1_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_b_item2_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127710/d2.png" />
                        <div className="win3_item_title_text">{t('win3_b_item2_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_b_item3_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728163210/d3.png" />
                        <div className="win3_item_title_text">{t('win3_b_item3_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_b_item4_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127912/d4.png" />
                        <div className="win3_item_title_text">{t('win3_b_item4_b')}</div>
                    </div>
                ),
            },
        ],
    };

    const listC = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1737540886806/d3.png',
        title: t('win3_c_title'),
        specList: [
            {
                desc: t('win3_c_item1_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon
                            className="win3_item_title_icon"
                            pc={
                                locale === 'ph'
                                    ? 'https://websiteoss.ecoflow.com/upload/image/1752458098781/d1.png'
                                    : 'https://websiteoss.ecoflow.com/upload/image/1723727559364/d1.png'
                            }
                        />
                        <div className="win3_item_title_text">{t('win3_c_item1_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_c_item2_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127710/d2.png" />
                        <div className="win3_item_title_text">{t('win3_c_item2_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_c_item3_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728163210/d3.png" />
                        <div className="win3_item_title_text">{t('win3_c_item3_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_c_item4_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127912/d4.png" />
                        <div className="win3_item_title_text">{t('win3_c_item4_b')}</div>
                    </div>
                ),
            },
        ],
    };

    const listAll = locale === 'kr' ? [listA, listB, listC] : [listA, listB];

    return (
        <div className={styles.modal}>
            <EfProductCompareC items={listAll} theme="transparent" />
        </div>
    );
}
